import apiClient from "../../lib/apiClient";

export const schoolsAPI = {
  // GET /api/schools
  getSchools: async (params = {}) => {
    try {
      // Debug: log params để kiểm tra

      const response = await apiClient.get("/schools", { params });

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy danh sách trường thất bại",
      };
    }
  },

  // GET /api/schools/:id
  getSchool: async (id) => {
    try {
      const response = await apiClient.get(`/schools/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy thông tin trường thất bại",
      };
    }
  },

  // POST /api/schools
  createSchool: async (schoolData) => {
    try {
      const response = await apiClient.post("/schools", schoolData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Tạo trường thất bại",
      };
    }
  },

  // ADMIN ONLY - GET /api/schools/pending
  getPendingSchools: async () => {
    try {
      const response = await apiClient.get("/schools/pending");
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          "Lấy danh sách trường chờ duyệt thất bại",
      };
    }
  },

  // ADMIN ONLY - POST /api/schools/:id/approve
  approveSchool: async (id) => {
    try {
      const response = await apiClient.post(`/schools/${id}/approve`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Duyệt trường thất bại",
      };
    }
  },

  // ADMIN ONLY - POST /api/schools/:id/reject
  rejectSchool: async (id, reason) => {
    try {
      const response = await apiClient.post(`/schools/${id}/reject`, {
        reason,
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Từ chối trường thất bại",
      };
    }
  },

  // USER - GET /api/schools/my-schools
  getMySchools: async (status) => {
    try {
      const params = status ? { status } : {};
      const response = await apiClient.get("/schools/my-schools", { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.message ||
          "Lấy danh sách trường của tôi thất bại",
      };
    }
  },
};
